export default __webpack_public_path__ + "static/media/FAVICON_20.0a106768.png";